import { IDocument } from '../interfaces';
import AxiosService from '../utils/axios-service';

export class DocumentService extends AxiosService {
  private static instance: DocumentService;

  constructor() {
    super('BFF_HELP_CENTER_URL');
  }

  static get getInstance(): DocumentService {
    if (!DocumentService.instance) {
      DocumentService.instance = new DocumentService();
    }
    return DocumentService.instance;
  }

  public async get(): Promise<any> {
    try {
      const url: string = 'document';
      const response: IDocument = await this.axios.post(url);
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  }
}

export default DocumentService.getInstance;
